import { render, staticRenderFns } from "./TheFooterAdmin.vue?vue&type=template&id=2cc2403e&"
import script from "./TheFooterAdmin.vue?vue&type=script&lang=js&"
export * from "./TheFooterAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports